import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import './css/index.css';

export default function LinearLoader() {
  return (
    <Box sx={{ width: '100%', position: 'fixed' }}>
      <LinearProgress />
    </Box>
  );
}

export function AbsoluteCircularProgress() {
  return <div className="absoluteSpinner"><CircularProgress /></div>;
}
